export const textModifyHooks = {
  useGenerateAnchorId(inputTitle: string | null) {
    const anchorId = inputTitle?.replace(/\s+/g, '-').toLowerCase();

    return anchorId;
  },
};
